import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import axios from 'axios'
import apiPath from './apiPath'

const api = {
  CreateStoreOpenSchedule(payload) {
    return requestPost(apiPath.STORE_OPEN_SCHEDULE.path, payload)
  },

  GetOneStoreOpenSchedule(storeOpenScheduleID) {
    return requestGet(
      `${apiPath.STORE_OPEN_SCHEDULE.path}/${storeOpenScheduleID}`
    )
  },

  GetAllStoreOpenSchedule(paging, sorting, filtering) {
    return requestGet(apiPath.STORE_OPEN_SCHEDULE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_orderType: filtering.orderType,
      f_status: filtering.status,
      f_beginDate: filtering.beginDate,
      f_endDate: filtering.endDate,
      f_beginDay: filtering.beginDay,
      f_endDay: filtering.endDay,
      f_beginHour: filtering.beginHour,
      f_endHour: filtering.endHour
    })
  },

  UpdateStoreOpenSchedule(storeOpenScheduleID, payload) {
    return requestPut(
      `${apiPath.STORE_OPEN_SCHEDULE.path}/${storeOpenScheduleID}`,
      payload
    )
  },

  DeleteStoreOpenSchedule(storeOpenScheduleID) {
    return requestDelete(
      `${apiPath.STORE_OPEN_SCHEDULE.path}/${storeOpenScheduleID}`
    )
  },

  GetOpenScheduleConfig() {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_GLOBAL_CONFIG.path
      }`,
      method: 'get'
    })
  }
}

export default api
